import { getRole } from '@/store/selectors';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { Box, Button, Flex, VStack } from '@chakra-ui/react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CustomHeading, Span } from 'shared-components';
import { AgentApplicantAuthorisationStatus } from 'types';
import { ApplicationState } from '../../../../store';
import ApplicantHeader from '../../../molecules/applicantHeader';
import { ProgrammeCard } from '../../../molecules/programmeCard';
import ProgrammeDetailsModal from './ProgrammeDetailsModal';
import { useTranslation } from "react-i18next";

export default function Programmes() {
    const { t } = useTranslation('common');
  const params = useParams();
  const { userId, applicationId, uni } = params;

  const role = useSelector(getRole);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { offers, agentAccessStatus } = useSelector((state: ApplicationState) => state.apply);

  const isAuthorisationDenied = agentAccessStatus === AgentApplicantAuthorisationStatus.AUTHORISATION_DENIED;

  const canEditOffer = hasPerm(role, P.EDIT_APPLY_OFFER) && !isAuthorisationDenied;
  return (
    <>
      <ApplicantHeader>
        <Box mb={8}>
          <Flex mb={2} flexWrap={'wrap'} rowGap={4} columnGap={3}>
            <CustomHeading
              data-selector="programmesHeader-name"
              level="h1"
              flexGrow={1}
              mb={0}
              wordBreak={'break-word'}
            >
              <Span fontWeight={'bold'}>{t('common:programmes')}</Span>
            </CustomHeading>
          </Flex>
        </Box>
      </ApplicantHeader>

      <Box mb={10} mt={10}>
        <VStack spacing={4} mt={2} alignItems="flex-start">
          {canEditOffer && (
            <Button
              data-selector="programmes-offer-new-button"
              variant="solid"
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              {t('common:offerNewProgramme')}
                                      </Button>
          )}
          {isModalOpen && canEditOffer && (
            <ProgrammeDetailsModal onClose={() => setIsModalOpen(false)} forceCreate={true} />
          )}
          {offers.map(offer => (
            <ProgrammeCard
              key={`offer-${offer.id}`}
              offer={offer}
              userId={userId}
              to={`/application/${uni}/${userId}/${applicationId}/offers/${offer.id}`}
            />
          ))}
        </VStack>
      </Box>
    </>
  );
}
